@if (currentOrders()?.length) {
  <sd-title [titleLevel]="2" class="is-main" customClass="brand--h5 is-regular">
    {{ 'order.currentOrders' | translate }}
  </sd-title>
}
@for (currentOrder of currentOrders(); track currentOrder.code) {
  <sd-order-details
    [order]="currentOrder"
    [titleLevelAccordion]="3"
    [isOpened]="currentOrder.code === orderCode()"
    (openRecommendedPriceModal)="onOpenRecommendedPriceModal()"
    (returnProductClicked)="toShipupReturnPage(currentOrder.code)"
  />
}

@if (pastOrders()?.length) {
  <sd-title [titleLevel]="2" customClass="brand--h5 is-regular" class="is-main">
    {{ 'order.pastOrders' | translate }}
  </sd-title>
}
@for (pastOrder of pastOrders(); track pastOrder.code) {
  <sd-order-details
    [order]="pastOrder"
    [titleLevelAccordion]="3"
    [isOpened]="pastOrder.code === orderCode()"
    (returnProductClicked)="toShipupReturnPage(pastOrder.code)"
    (openRecommendedPriceModal)="onOpenRecommendedPriceModal()"
    (downloadInvoiceClicked)="downloadInvoice(pastOrder.code)"
  />
}

@if (!currentOrders()?.length && !pastOrders()?.length) {
  <sd-title [titleLevel]="2" customClass="brand--h5 is-regular">
    {{ 'order.noOrder' | translate }}
  </sd-title>
}

<div class="c__actions-template justify-content-center">
  @if (hasNext()) {
    <button sd-button type="button" (click)="getNextPage()">
      {{ 'actions.showMore' | translate }}
    </button>
  }
</div>
